type FilterValue = string[] | string | null | undefined;
type DrillFilters = Record<string, FilterValue>;

export function buildDrillThroughParams({
  month,
  filters,
  filterKeys,
}: {
  month: string;
  filters?: DrillFilters;
  filterKeys?: string[];
}): URLSearchParams {
  const params = new URLSearchParams({ month: normalizeDateValue(month) });

  filterKeys?.forEach((key) => {
    const value = filters?.[key];
    if (Array.isArray(value)) {
      value.forEach((item) => appendParam(params, key, item));
      return;
    }
    appendParam(params, key, value);
  });

  return params;
}

export function getDrillFiltersFromSearch(searchParams: URLSearchParams, filterKeys: string[]): DrillFilters {
  return filterKeys.reduce<DrillFilters>((filters, key) => {
    const values = searchParams.getAll(key);
    filters[key] = key === "date_from" || key === "date_to" ? searchParams.get(key) : values;
    return filters;
  }, {});
}

function appendParam(params: URLSearchParams, key: string, value: FilterValue) {
  if (value === null || value === undefined) return;
  const normalized = key === "date_from" || key === "date_to" || key === "month"
    ? normalizeDateValue(value)
    : String(value).trim();
  if (normalized) params.append(key, normalized);
}

function normalizeDateValue(value: FilterValue): string {
  if (Array.isArray(value)) return normalizeDateValue(value[0]);
  if (value === null || value === undefined) return "";
  return String(value).trim().split("T")[0];
}
